//React
import React from "react";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myProfileAction from '../action/myProfileAction';
//Material-ui


//Add
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Part
import PartPageTitle from './PartPageTitle';
import PartPersonalityRelationTable from './PartPersonalityRelationTable';
import PartStarIcon from './PartStarIcon';
//Icon



class Comp extends React.Component {

  constructor(props) {
		super(props);
    this.state = {
      relation: '',
      relationSummary: null,
      relationStars: 0,
      relationComment: '',
      canvas:{
        height: 430,
        width: 60,
      },
      myElement: [],
      partnerElement: [],
    }
	}

  componentDidMount() {
    document.title = '性格相性診断 - パートナーズ';
    this._personalityRelationGet();
  }

  _personalityRelationGet() {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type1', this.props.match.params.type1);
    params.append('type2', this.props.match.params.type2);
    return axios.post(config.apiUri + "member/personalityRelationApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      this.setState({
        relation: res.data.relation.relation,
        relationSummary: res.data.relation.relation_summary,
        relationStars: res.data.relation.stars,
        relationComment: res.data.relation.relation_comment,
        myElement: [
          res.data.character1.type_element1,
          res.data.character1.type_element2,
          res.data.character1.type_element3,
          res.data.character1.type_element4,
          res.data.character1.type_element5,
          res.data.character1.type_element6,
          res.data.character1.type_element7,
          res.data.character1.type_element8,
        ],
        partnerElement: [
          res.data.character2.type_element1,
          res.data.character2.type_element2,
          res.data.character2.type_element3,
          res.data.character2.type_element4,
          res.data.character2.type_element5,
          res.data.character2.type_element6,
          res.data.character2.type_element7,
          res.data.character2.type_element8,
        ]
      });
    })
    .catch((err) => {
      alert( config.apiErrComment );
    })
  }


  _renderRelation(relationComment) {
    if (this.state.relation.match(/>/)) {
      return relationComment.replace(/MBTI1/g, 'あなた').replace(/MBTI2/g, 'パートナー');
    }
    else if (this.state.relation.match(/</)) {
      return relationComment.replace(/MBTI2/g, 'あなた').replace(/MBTI1/g, 'パートナー');
    }
    else {
      return relationComment;
    }
  }

  render() {

    return (
      <div style={{maxWidth:'600px', margin:'auto'}}>

        <PartPageTitle
          title={this.props.match.params.type1+'と'+this.props.match.params.type2 + 'の関係'}
          onback={ '/my/' }
        />

        <h2 align='center'>{this.state.relationSummary}</h2>
        <div align='center'>

          <PartStarIcon
            count={this.state.relationStars}
            style={{fontSize:'2em'}}
          />
        </div>

        <PartPersonalityRelationTable
          myType16={this.props.match.params.type1}
          myElement={this.state.myElement}
          partnerType16={this.props.match.params.type2}
          partnerElement={this.state.partnerElement}
        />

        <div style={{margin:'10px'}}>
          <h2>解説</h2>
          <div style={{whiteSpace: 'pre-line'}}>
            { this._renderRelation(this.state.relationComment) }
          </div>
        </div>
      </div>
    )

  }
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myProfileAction
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
